import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styles from './RoomTabs.module.css';

export default function RoomTabs({ onRoomSelect }) {
    const activeSteps = useSelector(state => state.visualizer.activeSteps);
    const currentStepIndex = useSelector(state => state.visualizer.currentStepIndex);

    // Derive unique rooms in the order they appear in activeSteps,
    // and remember the first step index for each room (jump target).
    const rooms = useMemo(() => {
        const seen = new Map();
        activeSteps.forEach((step, idx) => {
            const room = step.room;
            if (room && !seen.has(room)) {
                seen.set(room, idx);
            }
        });
        return Array.from(seen.entries()).map(([room, firstIndex]) => ({
            room,
            firstIndex
        }));
    }, [activeSteps]);

    const currentRoom = activeSteps[currentStepIndex]?.room;

    const handleRoomClick = (room, firstIndex) => {
        if (onRoomSelect) {
            onRoomSelect({ room, firstIndex });
        }
    };

    if (rooms.length <= 1) {
        return null;
    }

    return (
        <nav className={styles.tabs} aria-label="Room navigation">
            {rooms.map(({ room, firstIndex }) => {
                const isActive = room === currentRoom;
                return (
                    <button
                        key={room}
                        type="button"
                        className={`${styles.tab} ${isActive ? styles.active : ''}`}
                        onClick={() => handleRoomClick(room, firstIndex)}
                        aria-current={isActive ? 'page' : undefined}
                    >
                        <span className={styles.label}>{room}</span>
                    </button>
                );
            })}
        </nav>
    );
}
